// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f0501d0a","977":"bdc7efb9"}[chunkId] + ".chunk.js";
};